import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-social-instagram-1',
  standalone: true,
  templateUrl: '../../assets/social/instagram-1.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSocialInstagram1Icon {}
